// This file is auto-generated by @oracle/oraclejet-icu-l10n from src/resources/icu/bundle.json
// and should not be edited by hand. Update the JSON file and rerun the build to regenerate this content.

const bundle = {
  accAnnounceMovedKey: (p: { itemKey: string; position: string; referenceKey: string }) =>
    'Переміщено ' + p['itemKey'] + ' ' + p['position'] + ' ' + p['referenceKey'] + '.',
  accCommandKey: () => 'Команда',
  accControlKey: () => 'Закрити',
  accPositionAfter: () => 'після',
  accPositionBefore: () => 'до',
  accReorderInstructions: (p: { keyPressed: string }) =>
    'Натисніть та утримуйте клавіші ' +
    p['keyPressed'] +
    ' і Shift, а потім використовуйте клавіші зі стрілками, щоб змінити порядок.',
  calendarDateConverter_parseError: (p: { dateExample: string }) =>
    'Введіть таку дату завершення: ' + p['dateExample'] + '.',
  calendarMonthConverter_parseError: (p: { dateExample: string }) =>
    'Введіть такий місяць і рік: ' + p['dateExample'] + '.',
  chart_labelGroup: () => 'Група',
  chart_labelSeries: () => 'Серія',
  chart_labelValue: () => 'Значення',
  checkboxSet_requiredMessageDetail: () => "Обов'язково",
  checkbox_requiredMessageDetail: () => "Обов'язково",
  close: () => 'Закрити',
  collection_noData: () => 'Немає даних для відображення.',
  collection_selectAllRows: () => 'Вибрати всі рядки',
  collection_selectRow: (p: { ROW_NAME: string }) => 'Вибрати рядок ' + p['ROW_NAME'],
  collection_sortDisabled: () => 'Без можливості сортування',
  collection_sortEnabled: () => 'З можливістю сортування',
  confirmation: () => 'Підтвердження',
  datePicker_currentDate: () => 'Поточна дата',
  datePicker_goToToday: () => 'Перейти до поточного дня',
  datePicker_label: () => 'Вибір дати',
  datePicker_month: () => 'Місяць',
  datePicker_months: () => 'Місяці',
  datePicker_next: () => 'Далі',
  datePicker_nextDecade: () => 'Наступне десятиліття',
  datePicker_nextMonth: () => 'Наступний місяць',
  datePicker_prev: () => 'Назад',
  datePicker_prevDecade: () => 'Попереднє десятиліття',
  datePicker_prevMonth: () => 'Попередній місяць',
  datePicker_restricted: () => 'Обмежено',
  datePicker_selected: () => 'Вибрано',
  datePicker_today: () => 'Сьогодні',
  datePicker_weekNum: (p: { NUM: string }) => 'Тиждень ' + p['NUM'],
  datePicker_weekNumColLabel: () => 'Номер тижня',
  datePicker_year: () => 'Рік',
  datePicker_years: () => 'Роки',
  error: () => 'Помилка',
  expandableList_expandCollapseInstructionText: () =>
    'Щоб розгорнути або згорнути, використовуйте клавіші зі стрілками',
  expandableList_groupCollapse: () => 'Згорнуто',
  expandableList_groupExpand: () => 'Розгорнуто',
  filePicker_addFiles: () => 'Додати файли',
  filePicker_dropzonePrimaryText: () => 'Перетягнути',
  filePicker_dropzoneSecondaryText: () => 'Виберіть файл або перетягніть його сюди',
  filePicker_dropzoneSecondaryTextMultiple: () => 'Виберіть файли або перетягніть їх сюди',
  filePicker_multipleFileTypeUploadError: (p: { fileTypes: string }) =>
    'Неможливо передати файли типів ' + p['fileTypes'],
  filePicker_singleFileUploadError: () => 'Передайте один файл за раз',
  filePicker_singleTypeUploadError: (p: { fileType: string }) =>
    'Неможливо передати файл типу ' + p['fileType'],
  filePicker_unknownFileTypeUploadError: () => 'невідомо',
  formControl_clear: () => 'Очистити',
  formControl_day: () => 'День',
  formControl_helpAvailable: () => 'Довідка доступна',
  formControl_hide: () => 'Приховати',
  formControl_limitReached: (p: { CHARACTER_LIMIT: number }) =>
    'Ви досягли обмеження в ' +
    ((
      {
        one: new Intl.NumberFormat('uk').format(p['CHARACTER_LIMIT']) + '-символ',
        few: new Intl.NumberFormat('uk').format(p['CHARACTER_LIMIT']) + '-символи',
        many: new Intl.NumberFormat('uk').format(p['CHARACTER_LIMIT']) + '-символів'
      } as Partial<Record<Intl.LDMLPluralRule, string>>
    )[new Intl.PluralRules('uk').select(p['CHARACTER_LIMIT'])] ||
      new Intl.NumberFormat('uk').format(p['CHARACTER_LIMIT']) + '-символа') +
    '.',
  formControl_loading: () => 'Завантаження',
  formControl_maxLength: (p: { MAX_LENGTH: string }) =>
    'Можна ввести символів: не більше ' + p['MAX_LENGTH'] + '.',
  formControl_maxLengthRemaining: (p: { CHARACTER_COUNT: string }) =>
    'Залишилася така кількість символів: ' + p['CHARACTER_COUNT'] + '.',
  formControl_month: () => 'Місяць',
  formControl_readOnly: () => 'Лише для читання',
  formControl_requiredMessageDetail: () => 'Введіть значення.',
  formControl_show: () => 'Показати',
  formControl_year: () => 'Рік',
  gantt_labelDate: () => 'Дата',
  gantt_labelEnd: () => 'Кінець',
  gantt_labelLabel: () => 'Мітка',
  gantt_labelRow: () => 'Рядок',
  gantt_labelStart: () => 'Початок',
  indexer_disabledLabel: (p: { SECTION: string }) =>
    p['SECTION'] + '. Не знайдено відповідних розділів.',
  indexer_keyboardInstructionText: () => 'Натисніть клавішу Enter, щоб вибрати значення.',
  indexer_othersLabel: () => '#',
  indexer_separatorLabel: (p: { FROM_SECTION: string; TO_SECTION: string }) =>
    'Від ' + p['FROM_SECTION'] + ' до ' + p['TO_SECTION'] + '.',
  indexer_touchInstructionText: () =>
    'Двічі торкніться й утримайте, щоб увійти в режим жестів, а потім перетягніть угору або вниз, щоб змінити значення.',
  info: () => 'Відомості',
  inputDateMask_date_cleared: () => 'Дата зарахування',
  inputDateMask_dayPlaceholder: () => 'дд',
  inputDateMask_empty_segment: () => 'Порожній',
  inputDateMask_monthPlaceholder: () => 'мм',
  inputDateMask_yearPlaceholder: () => 'рррр',
  inputDatePicker_dateRangeOverflowMessageDetail: (p: { max: string }) =>
    'Введіть дату, що передує даті ' + p['max'] + ' або збігається з нею.',
  inputDatePicker_dateRangeUnderflowMessageDetail: (p: { min: string }) =>
    'Введіть дату, що не передує ' + p['min'] + '.',
  inputDatePicker_dateRestrictionMessageDetail: () => 'Введіть доступну дату.',
  inputDatePicker_instruction: () => 'Натисніть клавішу Tab, щоб отримати доступ до календаря.',
  inputDatePicker_selectDate: () => 'Вибрати дату',
  inputMonthMask_dateRangeOverflowMessageDetail: (p: { max: string }) =>
    'Введіть місяць або рік, які настають не пізніше ' + p['max'] + '.',
  inputMonthMask_dateRangeUnderflowMessageDetail: (p: { min: string }) =>
    'Введіть місяць або рік, які настають не раніше ' + p['min'] + '.',
  inputNumber_converterParseError: () => 'Введіть число.',
  inputNumber_decrease: () => 'Зменшення',
  inputNumber_increase: () => 'Збільшення',
  inputPassword_hidden: () => 'Пароль приховано',
  inputPassword_hide: () => 'Приховати пароль',
  inputPassword_show: () => 'Показати пароль',
  inputSensitiveText_hidden: () => 'Конфіденційний текст приховано',
  list_msgFetchCompleted: () => 'Завантажено',
  list_msgFetchingData: () => 'Завантаження',
  list_suggestion: () => 'Пропозиція',
  messageToast_allMessagesClosed: () => 'Усі спливні повідомлення закрито.',
  message_close: () => 'Закрити',
  message_confirmation: () => 'Виконано',
  message_error: () => 'Помилка',
  message_info: () => 'Відомості',
  message_navigationFromMessagesRegion: () =>
    'Вхід в область повідомлень. Натисніть клавішу F6, щоб повернутися до елемента, на якому раніше було встановлено фокус.',
  message_navigationToMessagesRegion: () =>
    'В області повідомлень наявні нові повідомлення. Натисніть клавішу F6, щоб перейти до останньої області повідомлень.',
  message_warning: () => 'Попередження',
  noData_message: () => 'Немає позицій для відображення',
  overflowItemLabel: () => 'Більше вкладок',
  plural_separator: () => ', ',
  progressIndeterminate: () => 'Триває',
  radio_helpForRadio: () => 'Довідка для перемикача',
  radio_requiredMessageDetail: () => 'Виберіть значення.',
  selectMultiple_apply: () => 'Застосувати',
  selectMultiple_back: () => 'Назад',
  selectMultiple_countPlus: (p: { COUNT: string }) => p['COUNT'] + '+',
  selectMultiple_highlightSelectedTagsInstructionText: () =>
    'Використовуйте клавіші зі стрілками вліво та вправо, щоб виділити вибрані значення.',
  selectMultiple_removeSelectedTagInstructionText: () =>
    'Натисніть клавішу Backspace або Delete, щоб вилучити вибране значення.',
  selectMultiple_selectedValues: () => 'Вибрані значення',
  selectMultiple_showSelectedValues: () => 'Показувати лише вибрані значення.',
  selectMultiple_valuesSelected: (p: { VALUE_COUNT: string }) =>
    'Вибрано таку кількість значень: ' + p['VALUE_COUNT'] + '.',
  select_addToList: () => 'Додати до списку',
  select_addToListAvailable: () => 'Додати до доступного списку',
  select_moreSearchOptions: () => 'Більше параметрів пошуку',
  select_moreSearchOptionsAvailable: () => 'Більше доступних параметрів пошуку',
  select_noMatchesFound: () => 'Збігів не знайдено.',
  select_oneMatchFound: () => 'Знайдено один збіг',
  select_requiredMessageDetail: () => 'Виберіть значення.',
  select_sizeMatchesFound: (p: { TOTAL_SIZE: string }) =>
    'Знайдено таку кількість збігів: ' + p['TOTAL_SIZE'],
  select_sizeOrMoreMatchesFound: (p: { TOTAL_SIZE: string }) =>
    'Знайдено ' + p['TOTAL_SIZE'] + ' або більше збігів',
  selectorAll_deselectAll: () => 'Скасувати вибір усього',
  selectorAll_selectAll: () => 'Вибрати все',
  selector_selected: () => 'Прапорець установлено',
  selector_unselected: () => 'Прапорець не встановлено',
  tabBarNavigationList_removeCueText: () => 'Можна вилучити',
  timeComponent_tooltipZoomIn: () => 'Збільшення',
  timeComponent_tooltipZoomOut: () => 'Зменшення',
  train_current: () => 'Поточний',
  train_message_type: () => 'Тип повідомлень',
  train_not_visited: () => 'Непереглянутий',
  train_status: (p: { currentStep: string; numberOfSteps: string }) =>
    'Крок ' + p['currentStep'] + ' із ' + p['numberOfSteps'],
  train_visited: () => 'Переглянутий',
  userAssistance_learnMore: () => 'Додаткові відомості',
  userAssistance_required: () => "Обов'язково",
  vis_clearSelection: () => 'Скасувати вибір',
  vis_drillable: () => 'З можливістю деталізації',
  vis_labelAndValue: (p: { LABEL: string; VALUE: string }) => p['LABEL'] + ': ' + p['VALUE'],
  vis_labelCountWithTotal: (p: { itemCount: string; totalCount: string }) =>
    p['itemCount'] + ' з ' + p['totalCount'],
  vis_marqueeSelectTooltip: () => 'Вибрати рухомий рядок',
  vis_marqueeZoomTooltip: () => 'Змінити масштаб рухомого рядка',
  vis_noData: () => 'Немає даних для відображення',
  vis_panTooltip: () => 'Панорамування',
  vis_stateLoaded: () => 'Завантажено',
  vis_stateLoading: () => 'Завантаження',
  vis_stateSelected: () => 'Вибрано',
  vis_stateUnselected: () => 'Не вибрано',
  warn: () => 'Попередження'
};
export default bundle;
